export default __webpack_public_path__ + "static/media/eb-ultra-blk-3.31cf9f88.png";